import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * `/sets/category/:tcgId/:setSlug`, a redirect stub.
 *
 * The set's cards live on the marketplace filtered by catalog group, which is
 * the endpoint that actually holds the listings, so this route exists only to
 * keep old links working. The redirect itself is untouched.
 *
 * It renders nothing on purpose. It used to mount the whole app Layout, a
 * spinner and a 478-line stylesheet for a component that replaces itself on its
 * first effect, and every one of those class names was legacy. A redirect that
 * paints a frame of chrome before navigating is a flash, not a loading state.
 */
export default function SetCardsPage() {
  const { setSlug } = useParams();
  const navigate = useNavigate();

  // Redirect to marketplace with catalog_group filter (same API as Marketplace)
  useEffect(() => {
    if (setSlug) {
      navigate(`/marketplace?catalog_group=${setSlug}`, { replace: true });
    }
  }, [setSlug, navigate]);

  return null;
}
